export const messages = {
  front_34: {
    defaultMessage: '3/4 front',
    id: 'avp.image.view.34_front',
  },
  front: {
    defaultMessage: 'front',
    id: 'avp.image.view.front',
  },
  rear_34: {
    defaultMessage: '3/4 rear',
    id: 'avp.image.view.34_rear',
  },
  rear: {
    defaultMessage: 'rear',
    id: 'avp.image.view.rear',
  },
  side: {
    defaultMessage: 'side',
    id: 'avp.image.view.side',
  },
  dashboard: {
    defaultMessage: 'dashboard',
    id: 'avp.image.view.dashboard',
  },
  wheels_rim: {
    defaultMessage: 'rims',
    id: 'avp.image.view.rims',
  },
};
